import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Accordion } from "react-bootstrap";
import faqsImage from "../Assets/faqsimage.svg";

const SavingsInvestment = () => {
  return (
    <div className="General-page">
      <div className="General-section mb-5">
        <h1>Savings & Investment</h1>
        <div>
          <Accordion defaultActiveKey="0" flush className="General-background">
            <Accordion.Item eventKey="1">
              <Accordion.Header>
                <h6 className="accordion-text">
                  How much can I invest on OVest?
                </h6>
              </Accordion.Header>
              <Accordion.Body className="accordion-bodyText">
                <div>
                  <p>Savest Plan (7% ROI every Month) - Min: ₦500 </p>
                  <p>Silvest Plan (50% ROI for 3 Months) - Min: ₦50,000</p>
                  <p>Goldvest Plan (125% ROI for 6 Months) - Min: ₦200,000</p>
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="2" className="General-background-one">
              <Accordion.Header>
                <h6 className="accordion-text">I’m ready, how do I invest?</h6>
              </Accordion.Header>
              <Accordion.Body className="accordion-bodyText">
                <div>
                  <p>
                    <strong>I'm Ready. How Do I Invest?</strong>
                  </p>
                  <p>
                    The investment process has been simplified with two methods
                    (online and offline).
                  </p>
                  <p>
                    <strong>Online </strong>{" "}
                  </p>
                  <p>
                    Online: Our web/mobile application portal is always
                    available. This means that you can invest at any time of the
                    day (24/7 x 365 days).
                  </p>
                  <p>
                    1. Create an account, following the Start Investing button
                    below/above.
                  </p>{" "}
                  <p>
                    2. Confirm your email account and update your profile with
                    the relevant information.
                  </p>
                  <p>
                    3. Fund your wallet by making a deposit online or bank
                    transfer with the amount to be invested.
                  </p>
                  <p>
                    4. Go to my Investment. Once you select the package you want
                    to invest in, the money would be automatically deducted from
                    your wallet. Then you begin the countdown to withdrawal day.
                    You can always access your investment account and track
                    daily growth/earnings.
                  </p>
                </div>

                <div>
                  <p>
                    <strong>Offline</strong>
                  </p>
                  <p>
                    Our office hours are between 9am - 5pm. You can also contact
                    us via{" "}
                    <a href="https://wa.me/2348060831576" target="blank">
                      WhatsApp
                    </a>{" "}
                    between Monday to Friday and you will be attended to by our
                    customer service agent to discuss your choice of investment.
                    Once you identify the plan of your choice, you can then
                    proceed to your OVest account to complete the steps stated
                    in step 3 and 4 of the online method. Then you begin the
                    countdown to withdrawal day.{" "}
                  </p>
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="4" className="General-background-one">
              <Accordion.Header>
                <h6 className="accordion-text">
                  Can I have multiple accounts?
                </h6>
              </Accordion.Header>
              <Accordion.Body className="accordion-bodyText">
                <p>
                  In OVest, multiple accounts are not allowed for the purpose of
                  proper investment management and prevention of fraud, but you
                  can have multiple active investments running simultaneously
                </p>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="5" className="General-background-one">
              <Accordion.Header>
                <h6 className="accordion-text">
                  Can I Invest if I am outside Nigeria?
                </h6>
              </Accordion.Header>
              <Accordion.Body className="accordion-bodyText">
                <p>
                  Yes! All you have to do is to follow the same investment
                  process stated above. Fill in your profile correctly and if
                  you face any difficulty, please contact us at{" "}
                  <a href="mailto:support@myovest.com">support@myovest.com.</a>
                </p>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="6" className="General-background-one">
              <Accordion.Header>
                <h6 className="accordion-text">
                  What rate of returns do I earn on my capital?
                </h6>
              </Accordion.Header>
              <Accordion.Body className="accordion-bodyText">
                <p>
                  In OVest, multiple accounts are not allowed for the purpose of
                  proper investment management and prevention of fraud, but you
                  can have multiple active investments running simultaneously
                </p>
                <p>Savest Plan offers 7% ROI every month</p>
                <p>Silvest Plan offers 50% ROI for 3 Months</p>
                <p>Goldvest Plan offers 125% ROI for 6 Months</p>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="7" className="General-background-one">
              <Accordion.Header>
                <h6 className="accordion-text">
                  How do my earnings accumulate on OVest?
                </h6>
              </Accordion.Header>
              <Accordion.Body className="accordion-bodyText">
                For every investment plan available on OVest, there is a
                maturity period. For each maturity period range, there is an
                attached interest rate. Remember, we make each day count by
                making your investment earn returns daily i.e. a daily breakdown
                of the interest rate is available in your investment plan(s)
                each day. Also, as big fans of compound interest, your returns
                compound whenever you rollover your plan after maturity.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="8" className="General-background-one">
              <Accordion.Header>
                <h6 className="accordion-text">
                  What does "Working Days" mean and how is it calculated?
                </h6>
              </Accordion.Header>
              <Accordion.Body className="accordion-bodyText">
                <p>
                  Working Days means Monday to Friday, we do not work on
                  weekends. This means
                </p>
                <p>● 25 Working Days is 35 days in total while</p>
                <p>● 30 Working Days is 45 days in total.</p>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="9" className="General-background-one">
              <Accordion.Header>
                <h6 className="accordion-text">
                  When does my investment begin to earn returns?
                </h6>
              </Accordion.Header>
              <Accordion.Body className="accordion-bodyText">
                <p>
                  Your plans start to earn returns the following day after you
                  begin investment on OVest and on a daily basis thereafter.
                  Your daily returns are credited to your OVest account at 12
                  midnight each day.
                </p>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="10" className="General-background-one">
              <Accordion.Header>
                <h6 className="accordion-text">
                  Can I monitor my investment and returns?
                </h6>
              </Accordion.Header>
              <Accordion.Body className="accordion-bodyText">
                <p>
                  Absolutely. Our OVestor dashboard was designed with this
                  objective in mind. You can monitor the progress on your
                  investment plans and returns on a daily basis via our
                  easy-to-understand dashboard. On the dashboard, you can view
                  the following:
                </p>
                <p>
                  ● Wallet: the total amount in your wallet currently. If you’ve
                  invested after you've funded your wallet, your wallet will
                  only display the remaining balance.
                </p>
                <p>
                  ● Earnings: the total amount of returns on your current
                  investment in your OVest account.
                </p>
                <p>
                  ● Referral Bonus: the total amount you have earned for
                  referring people to join us at OVest as an investor.
                </p>
              </Accordion.Body>
            </Accordion.Item>
           
          </Accordion>
          {/* <div className="General-background">
            <p>How much can I invest on OVest?</p>
            <div>
              <img src={faqsImage} alt="" />
            </div>
          </div>

          <div className="General-background-one">
            <p>I’m ready, how do I invest? </p>
            <div>
              <img src={faqsImage} alt="" />
            </div>
          </div>
          <div className="General-background-one">
            <p>Can I have multiple accounts?</p>
            <div>
              <img src={faqsImage} alt="" />
            </div>
          </div>
          <div className="General-background-one">
            <p>Can I invest if I’m outside Nigeria?</p>
            <div>
              <img src={faqsImage} alt="" />
            </div>
          </div>
          <div className="General-background-one">
            <p>What rate of return do I earn on my capital?</p>
            <div>
              <img src={faqsImage} alt="" />
            </div>
          </div>
          <div className="General-background-one">
            <p>How do my earnings accumulate on OVest?</p>
            <div>
              <img src={faqsImage} alt="" />
            </div>
          </div>
          <div className="General-background-one">
            <p>What does “working days” mean and how is it calculated?</p>
            <div>
              <img src={faqsImage} alt="" />
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default SavingsInvestment;
